import { PLATFORM } from 'aurelia-pal';
export function configure(config) {
	config.globalResources([
		PLATFORM.moduleName('./autocomplete/autocomplete'),
		PLATFORM.moduleName('./cards/autoheight-card'),
		PLATFORM.moduleName('./drag-and-drop/droppable'),
		PLATFORM.moduleName('./drag-and-drop/draggable'),
		PLATFORM.moduleName('./formula/formula-input'),
		PLATFORM.moduleName('./loader/loader'),
		PLATFORM.moduleName('./notifications/notifications-container'),
		PLATFORM.moduleName('./tree-view/tree-view'),
		PLATFORM.moduleName('./tree-view/tree-search'),
		PLATFORM.moduleName('app/component-model/template-elements'),
		PLATFORM.moduleName('./toggle-button/toggle-button'),
		PLATFORM.moduleName('./tabs/tab-view'),
		PLATFORM.moduleName('./tabs/tab-button'),
		PLATFORM.moduleName('./tabs/tab-container'),
		PLATFORM.moduleName('./global-select/customer/global-customer-select'),
		PLATFORM.moduleName('./global-select/scope/global-scope-select'),
		PLATFORM.moduleName('./column-views/two-column-view.html'),
		PLATFORM.moduleName('./editable-text/editable-text'),
		PLATFORM.moduleName('./sync-scroll/sync-scroll'),
		PLATFORM.moduleName('./inline-confirm/inline-element'),
		PLATFORM.moduleName('./inline-confirm/inline-button'),
		PLATFORM.moduleName('./inline-confirm/inline-confirm-button'),
		PLATFORM.moduleName('./inline-confirm/inline-confirm-container'),
		PLATFORM.moduleName('./toolbar-links/toolbar-links'),
		PLATFORM.moduleName('./side-bar/side-bar'),
		PLATFORM.moduleName('./side-bar/side-bar-button'),
		PLATFORM.moduleName('./side-bar/side-bar-container'),
		PLATFORM.moduleName('./nm-button/nm-button'),
		PLATFORM.moduleName('./combobox/combobox'),
		PLATFORM.moduleName('./match-height/match-height'),
		PLATFORM.moduleName('./limit-text/limit-text'),
		PLATFORM.moduleName('./hover-box/hover-box'),
		PLATFORM.moduleName('./tui-editor/tui-editor'),
		PLATFORM.moduleName('./notification-proxy/notification-proxy')
	]);
}
